import { IAdminImageListItem } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

//어드민 - 이미지 리스트 페이지: 테이블에 보여줄 리스트 데이터
async function getAdminImageList(
  parentOptionId: number,
  page: number
): Promise<AxiosResponse<FetchResult<IAdminImageListItem[]>>> {
  const response = await instance.get(`/admin/images?parentOptions=${parentOptionId}&page=${page}&take=15`);
  return response;
}

const useFetchAdminImageList = (parentOptionId: number, page: number) => {
  const { data: originalData, refetch } = useQuery({
    queryKey: ['get', `/admin/images?parentOptions=${parentOptionId}&page=${page}&take=15`],
    queryFn: () => getAdminImageList(parentOptionId, page),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(parentOptionId && page)
  });

  const response = originalData?.data;

  return { response, refetch };
};

export default useFetchAdminImageList;
